package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.AddDeliveriesResult
import com.milta.feature.route.domain.entity.DeliveryDraft
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/routes/{id}/deliveries — bulk-add stops to an already-dispatched route (DOM-02). */
class AddDeliveriesToRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(routeId: String, deliveries: List<DeliveryDraft>): AddDeliveriesResult =
        repository.addDeliveriesToRoute(routeId, deliveries)
}
